import {Vue} from 'ui.vue';

Vue.component('app-vue-components-form', {
	data()
	{
		return {
			data: {
				phone: '',
				name: '',
				chanel: 'звонок на телефон'
			},
			chanels: [
				'звонок на телефон',
				'TELEGRAM',
				'VIBER',
				'SMS'
			]
		}
	},
	methods: {
		showMessage(title,text) {
			let popup = new BX.PopupWindow("app-vue-components-form-message", null, {
					content: '<h2>'+title+'</h2><p>'+text+'</p>',
					autoHide: true,
					closeIcon: {right: "20px", top: "10px"},
					zIndex: 0,
					offsetLeft: 0,
					offsetTop: 0,
					draggable: {restrict: false},
					overlay: {backgroundColor: 'black', opacity: '80' },
					events: {
							onPopupClose: function () {
								this.destroy();
							}
						}
				});
			popup.show();
		},
		send() {
			let self = this
			BX.ajax({   
					url: '/local/ajax.php',
					data: this.data,
					method: 'POST',
					dataType: 'json',
					timeout: 30,
					async: true,
					processData: true,
					scriptsRunFirst: true,
					emulateOnload: true,
					start: true,
					cache: false,
					onsuccess: function(data){
						console.log(data)
						
						if (data.status) {
							self.showMessage('Ошибка!','Попробуйте позже');
                        } else {
							self.showMessage('Спасибо!','Наш менеджер свяжется с вами в ближайшее время');
						}
					},
					onfailure: function(){
						self.showMessage('Ошибка!','Попробуйте позже');
					}
				})
		}
	},
	computed: {
		valid() {
			return !!(this.data.phone.replace(/[^\d]/g, '').length==11 && this.data.name);
		}
	},
	watch: {
		'data.phone' (val,oval) {
			
			if (val.length > oval.length) {
			
				let phone = val.replace(/[^\d]/g, '').substring(0,11);
				let lenPhone = phone.length;
				let tt = phone.split('');
				
				if (lenPhone > 1) tt.splice(1,"", "(");
				if (lenPhone > 3) tt.splice(5,"", ")");
				if (lenPhone > 5) tt.splice(9,"", "-");
				if (lenPhone > 7) tt.splice(12,"", "-");
				
				let phone_formated = '+'+tt.join('');
				
				if (val != phone_formated) {
					this.data.phone = phone_formated;
				}
			}
		}
	},template: `
		<section class="form">
			<a href="#form" name="form"></a>
			<div class="container">
				<div class="form__grid">
					<div class="form__left">
					  <div class="form__title">
						<h2 class="fs80">давайте поговорим о вашем проекте</h2>
					  </div>
					</div>
					<div class="form__container">
						<p class="form__desc">оставьте свой телефон и мы свяжемся с вами</p>
						<form action="#"> 
							<div class="input-container">
								<input type="text" v-model="data.name" placeholder="Ваше имя">
								<div class="label">Ваше имя</div>
							</div>
							<div class="input-container">
							  <input type="text" v-model="data.phone" placeholder="номер телефона">
							  <div class="label">номер телефона</div>
							</div>
							<div class="input-container">
								<div class="label up">выберите удобный способ связи</div>
								<v-select 
										:options="chanels"
										v-model="data.chanel"
										label="выберите удобный способ связи"
									></v-select>
							</div>
						</form>
						<div class="form__row">
							<button class="btn btn--border" v-on:click.prevent="send" v-bind:disabled="!valid">отправить</button>
							<p>Нажимая кнопку Отправить, я даю согласие на Обработку персональных данных</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	`
});
